module.exports = __webpack_public_path__ + "static/img/ScheduleIcon-2.dcdef902.svg";